import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import { managerQuota, searchUsers } from '../../actions/admin/adminUserActions'

export const SEND_INVITES = 'ADMIN_USERS_INVITE_SEND'

export const GET_CODE = 'ADMIN_USERS_INVITE_GET_CODE'

export const CHANGE_CODE = 'ADMIN_USERS_INVITE_CHANGE_CODE'

export const sendInvites = inviteForm => dispatch => {
  return dispatch(
    h2Api.post('/admin/invite/sendInvites', inviteForm)({ type: SEND_INVITES })
  ).then(resp => {
    if (resp.success) {
      dispatch(formActions.reset('admin.users.invite.forms.inviteForm'))
    }

    dispatch(managerQuota())
    setTimeout(() => dispatch(searchUsers(true)), 1000)

    return resp
  })
}

export const getCode = () => dispatch => {
  return dispatch(h2Api.get('/admin/invite/getInviteCode')({ type: GET_CODE }))
}

export const changeInviteCode = () => dispatch => {
  return dispatch(h2Api.post('/admin/invite/changeInviteCode', {})({ type: CHANGE_CODE }))
}
